import {
  ContentTaskTagCombinationTagGq,
  ContentTaskTagCombinationTagGqProps,
} from './ContentTaskTagCombinationTagGq';
export interface ContentTaskTagCombinationGq {
  tags: ContentTaskTagCombinationTagGq[];
}

export const ContentTaskTagCombinationGqProps = `
    tags { ${ContentTaskTagCombinationTagGqProps} }
`;
